export default defineNuxtPlugin((nuxtApp) => {
  const { $i18n } = nuxtApp;
  nuxtApp.vueApp.config.globalProperties.$n = (value, format) => {
    if (value === null || value === undefined || isNaN(value)) {
      return '-'
    }
    return $i18n.n(Number(value), format)
  }
})
